import { IPoliticalPartyAddEditRequest } from '../../../../model/sge/political-party/request/political-party-add-edit-request';
import { IPoliticalPartyResponse } from '../../../../model/sge/political-party/response/political-party-response';
import { ValidationErrors, isBlank } from '../../../../utils/validation';

export type PoliticalPartyField = 'name' | 'abbreviation';

export function toPoliticalPartyForm(party?: IPoliticalPartyResponse): IPoliticalPartyAddEditRequest {
    return party
        ? { name: party.name, abbreviation: party.abbreviation, isActive: party.isActive }
        : { isActive: true };
}

export function validatePoliticalParty(form: IPoliticalPartyAddEditRequest): ValidationErrors<PoliticalPartyField> {
    const errors: ValidationErrors<PoliticalPartyField> = {};
    if (isBlank(form.name)) errors.name = 'Nome é obrigatório';
    if (isBlank(form.abbreviation)) errors.abbreviation = 'Sigla é obrigatória';
    return errors;
}
